// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__gJerg","title":"styles_title__2x55y","container":"styles_container__2Nu7n","subtitle":"styles_subtitle__1GD6L"};